import Header from "../components/Header";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";

function About() {
  return (
    <div className="bg-white min-h-screen">
      <Header />

      <PageBanner
        title="About Us"
        subtitle="We bring the nearest premium hotels and restaurants to your fingertips."
        image="https://images.unsplash.com/photo-1540541338287-41700207dee6?auto=format&fit=crop&w=1920&q=80"
      />

      <main className="max-w-7xl mx-auto px-6 py-20">
        <h2 className="text-3xl font-luxury font-semibold mb-6">Our Mission</h2>
        <p className="text-gray-700 mb-6 leading-relaxed">
          At MyTrip, our mission is to help travelers and locals discover premium
          hotels and exceptional dining experiences near them — instantly and
          effortlessly. We combine real-time geolocation, curated listings, and
          beautiful imagery to present choices that are both relevant and
          remarkable.
        </p>

        <h3 className="text-2xl font-semibold mb-4">How it works</h3>
        <ol className="list-decimal list-inside mb-8 text-gray-700">
          <li className="mb-2">We detect your location (with permission) to show nearby places.</li>
          <li className="mb-2">We fetch curated, premium listings and persist high-quality photos.</li>
          <li className="mb-2">You can call, visit the website, or get directions with a single tap.</li>
        </ol>

        <h3 className="text-2xl font-semibold mb-4">Why choose us</h3>
        <div className="grid md:grid-cols-3 gap-6">
          <div className="p-6 bg-white/90 rounded-lg shadow">
            <h4 className="font-semibold mb-2">Curated Quality</h4>
            <p className="text-gray-600 text-sm">We highlight premium hotels and top-rated restaurants only.</p>
          </div>

          <div className="p-6 bg-white/90 rounded-lg shadow">
            <h4 className="font-semibold mb-2">Fast Discovery</h4>
            <p className="text-gray-600 text-sm">Find nearby options quickly with precise distance info.</p>
          </div>

          <div className="p-6 bg-white/90 rounded-lg shadow">
            <h4 className="font-semibold mb-2">Easy Actions</h4>
            <p className="text-gray-600 text-sm">Call, visit, or get directions in one tap.</p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default About;
